import React from 'react';

import { songbookActionTypes } from './actions'
import { userActionTypes } from '../user/actions'
import moment from 'moment'
import { user } from '../user/reducers';
import { songActionTypes } from '../song/actions';


let _initialState = {
    isFetching: false,
    key: null,
    data: {
        results: []
    },
    privateSongbooks: {
        results:[] 
    },
    publicSongbooks: {
        results:[] 
    },
    sharedSongbooks: {
        results:[]
    },
    privateSongbookOrderType: 'created',
    publicSongbookOrderType: 'created',
    sharedSongbookOrderType: 'created',
}

const sortFunction = (a, b) => {
    return moment(b.created)-moment(a.created)
}

const titleSortFunction = (a, b) => {
    return a.title.localeCompare(b.title)
}

const songbookOrderSortFunction = (a, b) => {
    if (a.sort_order === b.sort_order) {
        return sortFunction(a, b)
    }
    if (a.sort_order === null || a.sort_order === undefined) {
        return 1
    }
    if (b.sort_order === null || b.sort_order === undefined) {
        return -1
    }
    return a.sort_order - b.sort_order
}

const sortSongbooks = (songbooks, orderType) => {
    if (orderType === 'title') {
        return songbooks.sort(titleSortFunction)
    }
    if (orderType === 'created') {
        return songbooks.sort(sortFunction)
    }
    return songbooks.sort(songbookOrderSortFunction)
}

export function songbooks(state = _initialState, action) {

    switch (action.type) {
        case songbookActionTypes.REQUEST:

            state = { ...state }
            state.isFetching = true

            return state

        case songbookActionTypes.RECEIVE:

            state = { ...state }
            state.isFetching = false

            if (action.shared) {
                let sharedData = action.data;
                let orderType = action.orderType || state.sharedSongbookOrderType || 'created'

                if (action.songbookId) {
                    let elementsIndex = state.sharedSongbooks.results.findIndex(element => element.id == action.songbookId )
                    state.sharedSongbooks.results[elementsIndex] = sharedData
                } else {
                    state.sharedSongbooks = {
                        'next': action.data.next,
                        'previous': action.data.previous,
                        'count': action.data.count,
                        'results': sortSongbooks(sharedData.results, orderType)
                    }
                }
            } else if (!action.onlyPublic) {
                let privData = action.data
                let orderType = action.orderType || state.privateSongbookOrderType || 'created'
                if (action.songbookId) {
                    let elementsIndex = state.privateSongbooks.results.findIndex(element => element.id == action.songbookId )
                    state.privateSongbooks.results[elementsIndex] = privData
                } else {
                    state.privateSongbooks = {
                        'next': action.data.next,
                        'previous': action.data.previous,
                        'count': action.data.count,
                        'results': sortSongbooks(privData.results, orderType)
                    }
                }
            } else {
                let pubData = action.data;
                let orderType = action.orderType || state.publicSongbookOrderType || 'created'

                if (action.songbookId) {
                    let elementsIndex = state.publicSongbooks.results.findIndex(element => element.id == action.songbookId )
                    state.publicSongbooks.results[elementsIndex] = pubData
                } else {
                    state.publicSongbooks = {
                        'next': action.data.next,
                        'previous': action.data.previous,
                        'count': action.data.count,
                        'results': sortSongbooks(pubData.results, orderType)
                    }
                }
            }

            state.onlyPublic = action.onlyPublic
            if (action.shared) {
                state.searchTextShared = action.searchQuery
                state.sharedSongbookOrderType = action.orderType || state.sharedSongbookOrderType || 'created'
            } else if (action.onlyPublic) {
                state.searchText = action.searchQuery
                state.publicSongbookOrderType = action.orderType || state.publicSongbookOrderType || 'created'
            } else {
                state.searchTextPriv = action.searchQuery
                state.privateSongbookOrderType = action.orderType || state.privateSongbookOrderType || 'created'
            }

            return state
        case songbookActionTypes.RECEIVE_UPDATE:
            state = { ...state }

            state.privateSongbooks.results = state.privateSongbooks.results.map(s => {
                if (s.id === action.data.id) {
                    return action.data
                } else {
                    return s
                }
            })

            state.publicSongbooks.results = state.publicSongbooks.results.map(s => {
                if (s.id === action.data.id) {
                    return action.data
                } else {
                    return s
                }
            })

            state.sharedSongbooks.results = state.sharedSongbooks.results.map(s => {
                if (s.id === action.data.id) {
                    return action.data
                } else {
                    return s
                }
            })

            return state

        case songbookActionTypes.RECEIVE_ORDER:
            state = { ...state }
            state.isFetching = false
            state.privateSongbooks = {
                ...state.privateSongbooks,
                results: action.data,
            }

            return state

        case userActionTypes.LOGOUT:
            state = _initialState;
            return state
        
        case songbookActionTypes.SET_ACTIVE_SONGBOOKS:

            state = {
                ...state,
                "activeSongbook": action.songbookType
            }
            return state

        case songbookActionTypes.SET_SONGBOOK_ORDER_TYPE:

            state = {
                ...state,
                [action.songbookType === 'public' ? 'publicSongbookOrderType' : action.songbookType === 'shared' ? 'sharedSongbookOrderType' : 'privateSongbookOrderType']: action.orderType,
            }
            return state

        default:
            return state
    }

}

export function songbook(state = {
    isFetching: false,
    key: null,
    data: {},
    ordering: {},
}, action) {

    switch (action.type) {
        case songbookActionTypes.REQUEST_DETAIL:

            state = { ...state }
            state.isFetching = true
            return state


        case songbookActionTypes.RECEIVE_DETAIL:

            state = { ...state }

            state.isFetching = false
            state.data = action.data

            return state

        case songbookActionTypes.REQUEST_UPDATE:

            state = { ...state }
            state.data = state.data ? state.data : {}
            state.isFetching = true

            return state

        case songbookActionTypes.RECEIVE_UPDATE:

            state = { ...state }

            state.isFetching = false
            state.data = action.data

            return state

        case songbookActionTypes.RECEIVE_ORDER:

            state = { ...state }
            state.isFetching = false

            return state

        default:
            return state
    }

}
